define([
	"dojo/_base/declare",
	"csi/action/_StateAction",
	"csi/action/_StateMachineStateActions",
	"csi/xml"
], function(declare,_StateAction,_StateMachineStateActions,xml) {

	return declare(_StateAction, {
		constructor: function(def) {
			// default right for Purge is Admin on master
			this.m_right = null;
			this.m_rightParent = xml.RIGHT_ADMIN;
		},

		_hasStateAccess: function(/*Context*/ctx, /*Node*/master, /*Node*/revision) {
			// summary: purge actions are not in map unless explicitly disabled
			var actions = _StateMachineStateActions[master.StateMachine];
			var	stateActions = actions ? actions[revision.State] : null;
			return stateActions && (stateActions[this.m_tag] !== false);
		}
	});
});